export default __webpack_public_path__ + "static/media/IMG_8690.f216ff8b.JPG";